import MoreCaseStudiesSection from './MoreCaseStudiesSection';

export default MoreCaseStudiesSection;
